import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { computed, ref, watch } from "vue";
// 子传父
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: ""
    }
  },
  emits: ["update:show", "change"],
  setup(__props, {
    emit: __emit
  }) {
    const emits = __emit;
    // 父传子
    const props = __props;
    const splitDateTime = value => {
      if (!value) return null;
      const normalized = value.replace("T", " ").trim();
      const [datePart, timePart = "00:00"] = normalized.split(" ");
      const [year, month, day] = datePart.split("-").map(Number);
      const [hour = 0, minute = 0] = timePart.split(":").map(Number);
      if (!year || !month || !day) return null;
      return {
        date: [year, month, day],
        time: [String(hour).padStart(2, "0"), String(minute).padStart(2, "0")]
      };
    };
    const getNowParts = () => {
      const now = new Date();
      return {
        date: [now.getFullYear(), now.getMonth() + 1, now.getDate()],
        time: [String(now.getHours()).padStart(2, "0"), String(now.getMinutes()).padStart(2, "0")]
      };
    };
    const nowParts = getNowParts();
    const currentDate = ref(nowParts.date);
    const currentTime = ref(nowParts.time);
    const syncValue = value => {
      const parsed = splitDateTime(value);
      if (!parsed) {
        const fallback = getNowParts();
        currentDate.value = fallback.date;
        currentTime.value = fallback.time;
        return;
      }
      currentDate.value = parsed.date;
      currentTime.value = parsed.time;
    };
    watch(() => props.show, visible => {
      if (!visible) return;
      syncValue(props.value);
    });
    watch(() => props.value, value => {
      if (!props.show) syncValue(value);
    });
    // 日期组件数据格式化显示
    const formatter = (type, option) => {
      const arr = [{
        type: "year",
        text: "年"
      }, {
        type: "month",
        text: "月"
      }, {
        type: "day",
        text: "日"
      }, {
        type: "hour",
        text: "时"
      }, {
        type: "minute",
        text: "分"
      }, {
        type: "second",
        text: "second"
      }];
      arr.forEach(item => {
        if (item.type === type) {
          option.text += item.text;
        }
      });
      return option;
    };
    // 计算属性
    let open = computed({
      set(val) {
        return emits("update:show", val);
      },
      get() {
        return props.show;
      }
    });
    // 日期确认按钮操作
    const onConfirm = () => {
      const paddedDate = currentDate.value.map(d => String(d).padStart(2, "0"));
      const paddedTime = currentTime.value.map(t => String(t).padStart(2, "0"));
      emits("change", paddedDate.join("-") + " " + paddedTime.join(":"));
      open.value = false;
    };
    return (_ctx, _cache) => {
      const _component_van_date_picker = _resolveComponent("van-date-picker");
      const _component_van_time_picker = _resolveComponent("van-time-picker");
      const _component_van_picker_group = _resolveComponent("van-picker-group");
      const _component_van_popup = _resolveComponent("van-popup");
      return _openBlock(), _createBlock(_component_van_popup, {
        show: _unref(open),
        "onUpdate:show": _cache[3] || (_cache[3] = $event => _isRef(open) ? open.value = $event : open = $event),
        position: "bottom"
      }, {
        default: _withCtx(() => [_createVNode(_component_van_picker_group, {
          tabs: ['选择日期', '选择时间'],
          onConfirm: onConfirm,
          onCancel: _cache[2] || (_cache[2] = $event => _isRef(open) //@ts-ignore
          ? open.value = false : open = false)
        }, {
          default: _withCtx(() => [_createVNode(_component_van_date_picker, {
            modelValue: currentDate.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => currentDate.value = $event),
            formatter: formatter
          }, null, 8, ["modelValue"]), _createVNode(_component_van_time_picker, {
            modelValue: currentTime.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => currentTime.value = $event),
            formatter: formatter
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["show"]);
    };
  }
});